import React, {
  useCallback,
  useEffect,
  useState
} from 'react'
import { contact } from "../lib/system";
import { Card, Button, Form } from 'react-bootstrap'
import { Link } from "react-router-dom";
import { Modal } from './common'

enum Progress {
  Input,
  Confirm,
  Succeeded
}

export default () => {
  const [progress, setProgress] = useState(Progress.Input)
  const [errorMessage, setErrorMessage] = useState('')
  const [modalShow, setModalShow] = useState(false);
  const [attempting, setAttempting] = useState(false)
  const [name, setName] = useState('')
  const [title, setTitle] = useState('')
  const [text, setText] = useState('')
  const [email, setEmail] = useState('')

  const handleNameChange = useCallback((e: any) => setName(e.target.value), [])
  const handleTitleChange = useCallback((e: any) => setTitle(e.target.value), [])
  const handleTextChange = useCallback((e: any) => setText(e.target.value), [])
  const handleEmailChange = useCallback((e: any) => setEmail(e.target.value), [])

  // hooks
  useEffect(() => {
    errorMessage !== "" && setModalShow(true)
  }, [errorMessage])

  useEffect(() => {
    !modalShow && setErrorMessage("")
  }, [modalShow])

  const handleContact = async () => {
    setAttempting(true)
    try {
      await contact(title, text, email, name);
      setAttempting(false);
      setProgress(Progress.Succeeded);
    } catch (err) {
      setErrorMessage((err as any)?.response?.data || "")
      setAttempting(false)
      setProgress(Progress.Input)
    }
  }

  const handleComfirm = () => {
    setAttempting(true)
    const flg: boolean = valid();
    if (flg) {
      setProgress(Progress.Confirm)
    }
    setAttempting(false)
  }

  const valid = () => {
    var pattern =
      /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;
    if (!email?.length) {
      setErrorMessage("email is Empty");
      return false;
    }
    else if (email?.length > 255) {
      setErrorMessage("email is invalid");
      return false;
    }
    else if (!pattern.test(email)) {
      setErrorMessage("email is invalid");
      return false;
    }
    else if (!name?.length) {
      setErrorMessage("name is Empty");
      return false;
    }
    else if (name?.length > 255) {
      setErrorMessage("name is invalid");
      return false;
    }
    else if (!title?.length) {
      setErrorMessage("title is Empty");
      return false;
    }
    else if (title?.length > 255) {
      setErrorMessage("title is invalid");
      return false;
    }
    else if (!text?.length) {
      setErrorMessage("text is Empty");
      return false;
    }
    else if (text?.length > 2000) {
      setErrorMessage("text is invalid");
      return false;
    } else {
      return true;
    }
  }

  const handleBack = () => {
    setAttempting(true)
    setProgress(Progress.Input)
    setAttempting(false)
  }

  return (
    <div id="contact">
      <div id="contents" className="container">
        <section>
          <Card className=''>
            <Modal
              show={modalShow}
              message={errorMessage}
              onHide={() => setModalShow(false)}
            />
            <Card.Header>お問合せ</Card.Header>
            <Card.Body>
              {progress === Progress.Input && input({
                handleNameChange,
                handleTitleChange,
                handleTextChange,
                handleEmailChange,
                handleComfirm,
                email,
                name,
                title,
                text,
                attempting
              })}
              {progress === Progress.Confirm && confirm({
                handleContact,
                handleBack,
                email,
                name,
                title,
                text,
                attempting
              })}
              {progress === Progress.Succeeded && success({
              })}
            </Card.Body>
          </Card>
        </section>
      </div>
    </div>
  );
};

const input = (props: any) => {
  return (
    <>
      <Form
        className="mb-4">
        <Form.Label>メールアドレス<span className="required">必須</span></Form.Label>
        <Form.Group>
          <Form.Control
            type="email"
            name="email"
            value={props.email}
            placeholder="メールアドレス"
            autoComplete="email"
            disabled={props.attempting}
            onChange={props.handleEmailChange}
            maxLength={255}
            className="mb-1" />
        </Form.Group>
        <Form.Label>名前<span className="required">必須</span></Form.Label>
        <Form.Group>
          <Form.Control
            type="text"
            name="name"
            value={props.name}
            placeholder="名前"
            autoComplete="name"
            disabled={props.attempting}
            onChange={props.handleNameChange}
            maxLength={255} />
        </Form.Group>
        <Form.Label>件名<span className="required">必須</span></Form.Label>
        <Form.Group>
          <Form.Control
            type="text"
            name="title"
            value={props.title}
            placeholder="件名"
            autoComplete="title"
            disabled={props.attempting}
            onChange={props.handleTitleChange}
            maxLength={255} />
        </Form.Group>
        <Form.Label>お問合せ内容<span className="required">必須</span></Form.Label>
        <Form.Group>
          <Form.Control
            as="textarea"
            rows={10}
            name="text"
            value={props.text}
            placeholder="お問合せ内容"
            autoComplete="text"
            disabled={props.attempting}
            onChange={props.handleTextChange}
            maxLength={2000} />
        </Form.Group>
      </Form>
      <Button
        className="btn-primary"
        disabled={props.attempting}
        onClick={props.handleComfirm}
        block>確認</Button>
    </>
  )
}

const confirm = (props: any) => {
  return (
    <React.Fragment>
      <div className="mb-3">こちらの内容でお間違いなければ送信ボタンをクリックしてください。</div>
      <Form
        className="mb-4">
        <Form.Label>メールアドレス</Form.Label>
        <Form.Group>
          {props.email}
        </Form.Group>
        <Form.Label>名前</Form.Label>
        <Form.Group>
          {props.name}
        </Form.Group>
        <Form.Label>件名</Form.Label>
        <Form.Group>
          {props.title}
        </Form.Group>
        <Form.Label>お問合せ内容</Form.Label>
        <Form.Group>
          <div className="prewrap">{props.text}</div>
        </Form.Group>
      </Form>
      <Button
        className="btn-info"
        disabled={props.attempting}
        onClick={props.handleContact}
        block>送信</Button>
      <Button
        variant="secondary"
        disabled={props.attempting}
        onClick={props.handleBack}
        block>戻る</Button>
    </React.Fragment>
  )
}

const success = (props: any) => {
  return (
    <React.Fragment>
      お問合せありがとうございました。
      <Link to="/">TOPへ</Link>
    </React.Fragment>
  )
}